module.exports = __webpack_public_path__ + "img/SKLB-Grupos.0efc9eb1.png";